import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import { CustomHttpResponse, SupplierCreditNoteFee } from '../../../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SupplierCreditNoteFeeService {
  apiService = inject(ApiHttpService<SupplierCreditNoteFee>);

  getForSupplierCreditNote(iri: string): Observable<SupplierCreditNoteFee[]> {
    return this.apiService
      .getMany(`${iri}/supplier_credit_note_fees`)
      .pipe(map((result) => result.body['hydra:member']));
  }

  create(fee: SupplierCreditNoteFee): Observable<SupplierCreditNoteFee> {
    return this.apiService
      .post(`/supplier_credit_note_fees`, fee)
      .pipe(map((result: CustomHttpResponse<SupplierCreditNoteFee>) => result.body));
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
